import { routeMatch } from '../route-match.js';
/**
 * Builds a route matcher that matches if part of the entry name equals to the expected string.
 *
 * @param expected - Expected part of the entry name.
 *
 * @returns New route matcher.
 */
export function rmatchString(expected) {
    return {
        test({ entry: { name }, nameOffset }) {
            return (name.substr(nameOffset, expected.length) === expected && {
                nameChars: expected.length,
            });
        },
        find({ route, entry: { name }, entryIndex, nameOffset, pattern, matcherIndex, }) {
            const start = name.indexOf(expected, nameOffset);
            if (start < 0) {
                return;
            }
            const match = routeMatch(route, pattern, {
                fromEntry: entryIndex,
                nameOffset: start + expected.length,
                fromMatcher: matcherIndex + 1,
            });
            if (!match) {
                return;
            }
            return [match, start];
        },
    };
}
//# sourceMappingURL=rmatch-string.js.map